/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const $lineItem = $(this).parents('[data-line-item]');

      // Custom-options parents carry their add-on lines with them
      const addonItemKeys = $lineItem.attr('data-addon-item-keys');
      if (addonItemKeys) {
        Shopify.theme.jsAjaxCart.removeItemWithAddons(addonItemKeys, $lineItem.attr('data-cart-item'));

        return false;
      }

      const lineID = $lineItem.data('line-item');
      Shopify.theme.jsAjaxCart.removeFromCart(lineID);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();

      return false;
    });

  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  removeItemWithAddons: function (addonItemKeys, parentItemKey) {
    const updates = {};
    updates[parentItemKey] = 0;

    addonItemKeys.split(',').filter(Boolean).forEach(function (key) {
      updates[key] = 0;
    });

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      contentType: 'application/json',
      data: JSON.stringify({ updates: updates }),
      dataType: 'json',
      success: function (cart) {
        Shopify.theme.jsAjaxCart.updateView();

        if (Shopify.theme.jsCart) {
          Shopify.theme.jsCart.refreshView(cart);
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  updateItemWithAddons: function (addonItemKeys, parentItemKey, quantity) {
    // Add-on lines are quantity-synced to their parent (Bold parity): the
    // parent row displays their price rolled up, so the two must never drift.
    const updates = {};
    updates[parentItemKey] = quantity;

    addonItemKeys.split(',').filter(Boolean).forEach(function (key) {
      updates[key] = quantity;
    });

    clearTimeout(Shopify.theme.jsAjaxCart._addonQtyTimer);
    Shopify.theme.jsAjaxCart._addonQtyTimer = setTimeout(function () {
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        contentType: 'application/json',
        data: JSON.stringify({ updates: updates }),
        dataType: 'json',
        success: function (cart) {
          Shopify.theme.jsAjaxCart.updateView();

          if (Shopify.theme.jsCart) {
            Shopify.theme.jsCart.refreshView(cart);
          }
        },
        error: function (XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;

        }
      });
    }, 350);
  },
  initializeAjaxCart: function () {

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        // Converting the currencies
        if (Shopify.theme.currencyConverter) {
          Shopify.theme.currencyConverter.convertCurrencies();
        }

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

      })
      .fail(() => {
        // some error handling
      });
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    const resetAddToCartBtn = function () {
      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    };

    const showFormWarning = function (message, markFormAsError) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${message}</p>`;

      $('.warning').remove();

      if (markFormAsError) {
        $addToCartForm.addClass('shopify-product-form--unselected-error');
      }

      $addToCartForm
        .find('.cart-warning')
        .html(cartWarning);

      resetAddToCartBtn();
    };

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      showFormWarning(Shopify.translation.select_variant, true);

      return;
    }

    // Migrated products (native custom options) render with no variant
    // preselected, a state the guard above never sees on a fresh load —
    // without this check the submit reaches /cart/add.js with
    // id="not-selected" and surfaces a raw server error.
    if (!parseInt($addToCartForm.find('[name="id"]').val(), 10)) {
      // 'unavailable' = all options chosen but no variant for them (or the
      // high-variant lookup is still in flight / failed).
      const isUnavailable = $addToCartForm.find('variant-selection').attr('variant') === 'unavailable';

      showFormWarning(isUnavailable ? Shopify.translation.unavailable : Shopify.translation.select_variant, true);

      return;
    }

    // Metaobject-driven custom options (see z__jsCustomOptions.js)
    if (Shopify.theme.customOptions) {
      const customOptionsCheck = Shopify.theme.customOptions.validate($addToCartForm[0]);

      if (!customOptionsCheck.valid) {
        showFormWarning(customOptionsCheck.message, true);

        return;
      }
    }

    $addToCartForm.find('.cart-warning').empty();

    const onBeforeSend = function () {
      $addToCartBtn
        .attr('disabled', 'disabled')
        .addClass('disabled');

      $addToCartBtn.find('span')
        .removeClass("fadeInDown")
        .addClass('animated zoomOut');
    };

    const onAddSuccess = function (response) {
      if(!response.items
         && typeof window.BOLD !== 'undefined'
         && typeof window.BOLD.common !== 'undefined'
         && typeof window.BOLD.common.cartDoctor !== 'undefined') {
        // NOTE: "cart" should be the variable containing the cart json data
        response = window.BOLD.common.cartDoctor.fixItem(response);
      }
      let $el = $('[data-ajax-cart-trigger]');

      $addToCartBtn
        .find('.checkmark')
        .addClass('checkmark-active');

      function addedToCart() {

        if (!isScreenSizeLarge()) {
          $el = $('.mobile-header [data-ajax-cart-trigger]');
          Shopify.theme.scrollToTop($el);
        } else {
          $el = $('[data-ajax-cart-trigger]');
        }

        $el.addClass('show-mini-cart');

        $addToCartBtn.find('span')
          .removeClass('fadeInDown');
      }

      window.setTimeout(function () {
        $addToCartBtn
          .removeAttr('disabled')
          .removeClass('disabled');

        $addToCartBtn.find('.checkmark')
          .removeClass('checkmark-active');

        $addToCartBtn.find('.text, .icon')
          .removeClass('zoomOut')
          .addClass('fadeInDown');

        $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

      }, 1000);

      Shopify.theme.jsAjaxCart.showDrawer();
      Shopify.theme.jsAjaxCart.updateView();

      if (Shopify.theme.jsCart) {
        $.ajax({
          dataType: "json",
          async: false,
          cache: false,
          dataType: 'html',
          url: "/cart",
          success: function (html) {
            const cartForm = $(html).find('.cart__form');
            $('.cart__form').replaceWith(cartForm);

          }
        });
      }
      if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
             typeof BOLD.common.eventEmitter.emit === 'function'){
           BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
      }

    };

    const onAddError = function (XMLHttpRequest) {
      let response = eval('(' + XMLHttpRequest.responseText + ')');
      response = response.description;

      showFormWarning(response.replace('All 1 ', 'All '), false);
    };

    let formData = window.FormData ? new FormData($addToCartForm[0]) : null;

    if (formData && Shopify.theme.customOptions) {
      formData = Shopify.theme.customOptions.cleanFormData(formData, $addToCartForm[0]);
    }

    const addons = formData && Shopify.theme.customOptions
      ? Shopify.theme.customOptions.getAddonItems($addToCartForm[0])
      : [];

    if (addons.length > 0) {
      // Priced add-ons are real products: the parent and its add-ons go up
      // together in a single JSON multi-add, linked through _addon_key so
      // the cart can remove them as a group.
      const quantity = parseInt(formData.get('quantity'), 10) || 1;
      const properties = {};

      for (const pair of formData.entries()) {
        const match = pair[0].match(/^properties\[([\s\S]*)\]$/);
        if (match) properties[match[1]] = pair[1];
      }

      const addonKey = `${formData.get('id')}-${Date.now()}`;
      properties._addon_key = addonKey;

      const payload = {
        items: [
          { id: Number(formData.get('id')), quantity: quantity, properties: properties },
          ...addons.map(function (addon) {
            return { id: addon.id, quantity: quantity, properties: { _addon_for: addonKey } };
          })
        ]
      };

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        contentType: 'application/json',
        data: JSON.stringify(payload),
        beforeSend: onBeforeSend,
        success: onAddSuccess,
        error: onAddError
      });
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: formData || $addToCartForm.serialize(),
        contentType : false,
        processData : false,
        beforeSend: onBeforeSend,
        success: onAddSuccess,
        error: onAddError
      });
    }
  },
  updateView: function () {

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {

      if (options.item_count > 0) {
        const itemList = $(html.content).find('.ajax-cart__list');
        const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');

        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      if (Shopify.theme.currencyConverter) {
        Shopify.theme.currencyConverter.convertCurrencies();
      }
      if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
                 typeof BOLD.common.eventEmitter.emit === 'function'){
               BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}

/******/ })()
;